import React from 'react';
import Banner from '../components/Banner';
import SEO from '../components/SEO';
import ServiceBg from '../images/resource-bg.jpeg';
import '../styles/pages/NewsDetails.css';
import Breadcrumb from '../components/Breadcrumb'

import { motion } from "framer-motion";
import { useParams, Link } from "react-router-dom";
import newsData from "../data/newsData";

function NewsDetails() {

    const { slug } = useParams();

    const article = newsData.find(
        item => item.slug === slug
    );

    if (!article) return <h2>Article Not Found</h2>;


    const recentPosts = newsData.slice(0, 5);


    return (

        <>

            <SEO
                title={article.title}
                description={article.desc}
            />

            <Banner
                title={article.title}
                image={ServiceBg}
            />



            <section className="news-wrapper pt-3">
                <div className="container">
                    <Breadcrumb />
                </div>

                <div className="container">

                    <div className="row">



                        {/* LEFT CONTENT */}

                        <div className="col-lg-8">


                            <div className="news-container">


                                <img
                                    src={article.image}
                                    alt={article.title}
                                    className="news-featured"
                                />



                                <div className="news-meta">

                                    <span>{article.date}</span>

                                    <span>{article.author}</span>

                                    <span>{article.category}</span>

                                </div>



                                <h1>

                                    {article.title}

                                </h1>



                                <p
                                    className="news-intro"
                                    style={{ whiteSpace: "pre-line" }}
                                >

                                    {article.intro}

                                </p>



                                {article.sections.map((sec, index) => (

                                    <div key={index}>

                                        <div className="divider" />

                                        <h2>{sec.heading}</h2>

                                        {sec.text && (

                                            <p style={{ whiteSpace: "pre-line" }}>

                                                {sec.text}

                                            </p>

                                        )}


                                        {sec.list && (

                                            <ul>

                                                {sec.list.map((item, i) => (

                                                    <li key={i}>

                                                        {item}

                                                    </li>

                                                ))}

                                            </ul>

                                        )}

                                    </div>

                                ))}



                                <div className="quote-box">

                                    "{article.quote}"

                                </div>




                                {/* COMMENT FORM */}

                                <div className="comment-section">

                                    <h3>Leave a Reply</h3>

                                    <p>Your email address will not be published.</p>


                                    <form>

                                        <input
                                            type="text"
                                            placeholder="Name *"
                                        />

                                        <input
                                            type="email"
                                            placeholder="Email *"
                                        />

                                        <input
                                            type="text"
                                            placeholder="Website"
                                        />

                                        <textarea
                                            rows="6"
                                            placeholder="Comment *"
                                        />

                                        <button className='bg-purple'>

                                            Post Comment

                                        </button>

                                    </form>

                                </div>



                            </div>

                        </div>




                        {/* RIGHT SIDEBAR */}

                        <div className="col-lg-4">

                            <div className="sidebar">


                                {/* SEARCH */}

                                <div className="widget">

                                    <h4>Search</h4>

                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        className="search-box"
                                    />

                                </div>



                                {/* RECENT POSTS */}

                                <div className="widget">

                                    <h4>Recent Posts</h4>

                                    <ul>

                                        {recentPosts.map(post => (

                                            <li key={post.id}>

                                                <Link to={`/resources/${post.slug}`}>

                                                    {post.title}

                                                </Link>

                                            </li>

                                        ))}

                                    </ul>

                                </div>




                                {/* RECENT COMMENTS */}

                                <div className="widget">

                                    <h4>Recent Comments</h4>

                                    <ul>

                                        <li>Admin on Customer Onboarding</li>

                                        <li>John on Cloud Services</li>

                                        <li>David on Training Programs</li>

                                    </ul>

                                </div>




                                {/* ARCHIVES */}

                                <div className="widget">

                                    <h4>Archives</h4>

                                    <ul>

                                        <li>May 2021</li>

                                        <li>April 2021</li>

                                        <li>March 2021</li>

                                    </ul>

                                </div>




                                {/* CATEGORIES */}

                                <div className="widget">

                                    <h4>Categories</h4>

                                    <ul>

                                        <li>Customer Success</li>

                                        <li>Training</li>

                                        <li>Cloud Services</li>

                                        <li>Technology</li>

                                    </ul>

                                </div>



                            </div>

                        </div>



                    </div>

                </div>

            </section>

        </>

    )

}

export default NewsDetails;